import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Notification } from './notification.model';

@ Injectable({providedIn: 'root'})
export class NotificationService {
	private url: string;

	constructor(private httpClient: HttpClient) {
		this.url = 'api/notification';
	}

	public getNotifications(user: string = null as any): Observable<Notification[]> {
		if (!user) {
			return this.httpClient.get<Notification[]>(this.url);
		}
		return this.httpClient.get<Notification[]>(this.url + '?userEmail=' + user);
	}

	public dismissNotification(id: number): Observable<any> {
		return this.httpClient.post<any>(this.url + '/dismiss', id);
	}

	public getDismissedNotifications(userEmail: string): Observable<Notification[]> {
		return this.httpClient.get<Notification[]>(this.url + '/GetDismissed?userEmail=' + userEmail);
	}

	public dismissNotificationToAllUser(NotificationId: number): Observable<any> {
		return this.httpClient.post<any>(this.url + '/DismissNotificationToAllUsers', NotificationId);
	}

}
